import { render } from "./PlayerControls.vue?vue&type=template&id=1929ef18&scoped=true"
import script from "./PlayerControls.vue?vue&type=script&lang=ts"
export * from "./PlayerControls.vue?vue&type=script&lang=ts"

import "./PlayerControls.vue?vue&type=style&index=0&id=1929ef18&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1929ef18"

export default script